"use client";

import { motion, useReducedMotion } from "framer-motion";
import { GraduationCap } from "lucide-react";
export default function Biography() {
  const shouldReduceMotion = useReducedMotion();
  const credentials = [{
    university: "Marmara Üniversitesi",
    faculty: "Hukuk Fakültesi — Hukuk Lisansı"
  }, {
    university: "Anadolu Üniversitesi",
    faculty: "İktisat Fakültesi — Kamu Yönetimi Lisans Programı"
  }, {
    university: "İstanbul Medeniyet Üniversitesi",
    faculty: "Bilişim ve Teknolojileri Hukuku — Tezli Yüksek Lisans"
  }];
  return <section id="founderbiography" data-nav="dark" className="relative w-full overflow-x-clip bg-background py-24 md:py-36 px-6 md:px-12">
      <div className="mx-auto w-full max-w-7xl">
        <div className="mb-12 md:mb-16 flex flex-col gap-2">
          <span className="font-sans text-xs uppercase tracking-widest text-muted-foreground">
            HAKKIMIZDA
          </span>
          <h2 className="font-serif font-semibold text-foreground text-[clamp(2rem,4vw,2.75rem)] leading-[1.15] tracking-tight">
            Kurucumuz
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div className="lg:col-span-5 flex flex-col gap-8">
            {}
            <div className="group relative overflow-hidden border border-border/40 bg-card">
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1774244/img/image-1.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1774244/img/image-1.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1774244/img/image-1.jpg-wvc-sizes" alt="Av. Raci Çetin Yüksekbaş" loading="lazy" className="h-full w-full object-cover object-center grayscale contrast-110 transition-transform duration-400 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.02]" />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent opacity-60" />
              </div>
            </div>

            {}
            <div>
              <span className="font-sans text-xs uppercase text-muted-foreground tracking-widest block mb-2">
                Kurucu Avukat & Danışman
              </span>
              <h1 className="font-serif font-semibold text-foreground text-[clamp(2rem,4vw,2.75rem)] leading-[1.15] tracking-tight">
                Av. Raci Çetin Yüksekbaş
              </h1>
            </div>

            {}
            <div className="flex flex-col border-t border-border/30 pt-2">
              <div className="flex items-center gap-2 mb-4">
                <GraduationCap className="size-4 text-foreground/70" />
                <span className="font-sans text-xs text-foreground/70 uppercase">
                  Akademik Geçmiş & Formasyon
                </span>
              </div>

              <div className="flex flex-col gap-4">
                {credentials.map((cred, i) => <div key={cred.university} data-index={i} className="flex flex-col gap-0.5">
                    <span className="font-sans text-base font-semibold text-foreground">
                      {cred.university}
                    </span>
                    <span className="font-sans text-sm text-foreground/60">
                      {cred.faculty}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col gap-10">
            <div className="flex flex-col gap-6 font-sans text-[clamp(1rem,1.2vw,1.0625rem)] text-foreground/80 leading-[1.75]">
              <p>
                Av. Raci Çetin Yüksekbaş, Adana&apos;nın Seyhan ilçesinde doğdu. İlk ve ortaöğrenimini Adana&apos;da tamamladıktan sonra 2015 yılında üniversite öğrenim için İstanbul&apos;a yerleşti.
              </p>
              <p>
                Marmara Üniversitesi Hukuk Fakültesinden mezun oldu. Hukuk öğreniminin yanı sıra Anadolu Üniversitesi İktisat Fakültesi nezdindeki Kamu Yönetimi lisans programını da 2020 yılında tamamladı. 2021 yılında İstanbul Medeniyet Üniversitesi Bilişim ve Teknolojileri Hukuku tezli yüksek lisans programında lisansüstü eğitimine başladı. Bu dönemde özellikle teknolojik gelişmelerin hukuk üzerindeki etkileri, bilişim hukuku ve dijital alanda ortaya çıkan hukuki meseleler üzerine çalışarak 2023 yılında programdan mezun oldu.
              </p>
              <p>
                Meslek hayatını serbest avukat olarak sürdüren Yüksekbaş, 2021 yılında Yüksekbaş Hukuk ve Danışmanlık&apos;ı kurdu. Avukatlık faaliyetleri kapsamında özel hukuk, kamu hukuku ve teknolojiyle kesişen hukuki meseleler başta olmak üzere farklı alanlarda çalışmalar yürütmektedir.
              </p>
              <p>
                Mesleki çalışmalarının yanında hukuk alanındaki akademik ve eğitsel faaliyetlerine de devam etmektedir. Çeşitli eğitim ve etkinliklerde hukuk uygulamasına ilişkin çalışmalar yürütmüş; hukuki çalışmaları mesleki yayınlarda yer almıştır.
              </p>
              <p>
                Hukuk dışındaki çalışmalarında Türk sanat müziğiyle profesyonel düzeyde ilgilenmekte; ney ve klarnet icra etmektedir. Bunun yanında tarih, mimari, edebiyat, felsefe, din ve etimoloji alanlarında düzenli okumalar yapmakta ve bu alanlarla uzun süredir ilgilenmektedir.
              </p>
              <p>
                Hâlen İstanbul&apos;da avukatlık ve hukuki danışmanlık faaliyetlerini Yüksekbaş Hukuk ve Danışmanlık bünyesinde sürdürmektedir.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}